export const {
  AWS_CONFIG: {
    ONECBO,
    CWB,
    ASSESS,
    DCA,
    TURBOCODE,
    DEP,
    AIP,
    TRUNORTHCODEDISCOVERY,
    SASMODERNIZER,
  },
} = window;
